const field = (key, label, placeholder, options = {}) => ({
  key,
  label,
  placeholder,
  ...options,
});

export const registryFieldGroups = t => [
  {
    columns: 2,
    fields: [
      field(
        'escritura',
        t('SALES_PROPERTY.REGISTRY.WRITING'),
        t('SALES_PROPERTY.REGISTRY.WRITING_PLACEHOLDER'),
        { select: true, required: true }
      ),
      field(
        'vagas',
        t('SALES_PROPERTY.REGISTRY.PARKING'),
        t('SALES_PROPERTY.REGISTRY.PARKING_PLACEHOLDER')
      ),
    ],
  },
  {
    columns: 4,
    fields: [
      field(
        'matricula',
        t('SALES_PROPERTY.REGISTRY.REGISTRATION'),
        t('SALES_PROPERTY.REGISTRY.REGISTRATION_PLACEHOLDER'),
        { required: true }
      ),
      field(
        'inscricaoMunicipal',
        t('SALES_PROPERTY.REGISTRY.MUNICIPAL'),
        t('SALES_PROPERTY.REGISTRY.MUNICIPAL_PLACEHOLDER'),
        { required: true }
      ),
      field(
        'rgi',
        t('SALES_PROPERTY.REGISTRY.RGI'),
        t('SALES_PROPERTY.REGISTRY.RGI_PLACEHOLDER'),
        { required: true }
      ),
      field(
        'cartorio',
        t('SALES_PROPERTY.REGISTRY.NOTARY'),
        t('SALES_PROPERTY.REGISTRY.NOTARY_PLACEHOLDER')
      ),
    ],
  },
  {
    columns: 4,
    fields: [
      field(
        'lavrada',
        t('SALES_PROPERTY.REGISTRY.RECORDED_AT'),
        t('SALES_PROPERTY.REGISTRY.RECORDED_AT_PLACEHOLDER')
      ),
      field(
        'livro',
        t('SALES_PROPERTY.REGISTRY.BOOK'),
        t('SALES_PROPERTY.REGISTRY.BOOK_PLACEHOLDER')
      ),
      field(
        'folha',
        t('SALES_PROPERTY.REGISTRY.PAGE'),
        t('SALES_PROPERTY.REGISTRY.PAGE_PLACEHOLDER')
      ),
      field(
        'ato',
        t('SALES_PROPERTY.REGISTRY.ACT'),
        t('SALES_PROPERTY.REGISTRY.ACT_PLACEHOLDER')
      ),
    ],
  },
];

export const registryPendencies = t => [
  { key: 'taxaIncendioAtrasada', label: t('SALES_PROPERTY.REGISTRY.FIRE_TAX') },
  { key: 'dividasIptu', label: t('SALES_PROPERTY.REGISTRY.IPTU') },
  { key: 'nonoDistrito', label: t('SALES_PROPERTY.REGISTRY.TAX_DISTRIBUTOR') },
];

export const formatRegistryDate = value => {
  const digits = String(value || '')
    .replace(/\D/g, '')
    .slice(0, 8);
  return digits
    .replace(/^(\d{2})(\d)/, '$1/$2')
    .replace(/^(\d{2}\/\d{2})(\d)/, '$1/$2');
};
